import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AddressForm } from './address-form';
import { ProposalForm } from './proposal-form';

export class ProposalRequestVendorForm extends FormGroup<{
  id: FormControl<number | undefined>;
  ProposalRequestId: FormControl<number | undefined>;
  VendorId: FormControl<number | undefined | null>;
  ExemptVendorId: FormControl<number | undefined | null>;
  InvitationContactId: FormControl<number | undefined>;
  dba: FormControl<string | null>;
  legalName: FormControl<string | undefined>;
  firstName: FormControl<string | undefined>;
  lastName: FormControl<string | undefined>;
  phoneExt: FormControl<string | undefined | null>;
  phone: FormControl<string | undefined>;
  phone2Ext: FormControl<string | undefined | null>;
  phone2: FormControl<string | null>;
  email: FormControl<string | null>;
  SubNationalDivisionId: FormControl<number | undefined>;
  acceptsRequest: FormControl<boolean | null>;
  isAwarded: FormControl<boolean>;
  status: FormControl<
    'CREATED' | 'ALERTED' | 'AWARDED' | 'INVITED' | 'NOTIFIED' | 'REJECTED'
  >;

  Address: AddressForm;
  Proposal?: ProposalForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ProposalRequestId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      VendorId: new FormControl<number | undefined | null>(undefined),
      ExemptVendorId: new FormControl<number | undefined | null>(undefined),
      InvitationContactId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      dba: new FormControl<string | null>(null),
      legalName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      firstName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      lastName: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      phoneExt: new FormControl<string | undefined | null>(null),
      phone: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      phone2Ext: new FormControl<string | undefined | null>(null),
      phone2: new FormControl<string | null>(null),
      email: new FormControl<string | null>(null, {
        validators: [Validators.required]
      }),
      SubNationalDivisionId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      acceptsRequest: new FormControl<boolean | null>(null),
      isAwarded: new FormControl<boolean>(false, { nonNullable: true }),
      status: new FormControl<
        'CREATED' | 'ALERTED' | 'AWARDED' | 'INVITED' | 'NOTIFIED' | 'REJECTED'
      >('CREATED', { nonNullable: true, validators: [Validators.required] }),

      Address: new AddressForm()
    });
  }
}

/*
declinedDate?: Date;
isSelectedForReport?: boolean;

// Alias column(s)
bidStatus?: 'BID SUBMITTED' | 'BID NOT SUBMITTED';

ProposalRequest?: ProposalRequest;
Vendor?: Vendor;
ExemptVendor?: ExemptVendor;
SubNationalDivision?: SubNationalDivision;
Proposal?: Proposal;
*/
